var ArticlesData = React.createContext({});
export var ArticlesDataProvider = ArticlesData.Provider;
export var ArticlesDataConsumer = ArticlesData.Consumer;
export default ArticlesData;